import { render, staticRenderFns } from "./step2_user.vue?vue&type=template&id=a2880482&scoped=true&"
import script from "./step2_user.vue?vue&type=script&lang=js&"
export * from "./step2_user.vue?vue&type=script&lang=js&"
import style0 from "./step2_user.vue?vue&type=style&index=0&id=a2880482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2880482",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VDatePicker,VDialog,VSelect,VSpacer,VTimePicker})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2880482')) {
      api.createRecord('a2880482', component.options)
    } else {
      api.reload('a2880482', component.options)
    }
    module.hot.accept("./step2_user.vue?vue&type=template&id=a2880482&scoped=true&", function () {
      api.rerender('a2880482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Report/step2_user.vue"
export default component.exports